<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.71,4.29C13.71,4.29,9.71,0.29,9.71,0.29C9.530000000000001,0.11,9.280000000000001,0,9,0C9,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1,2,15,2,15C2,15.55,2.45,16,3,16C3,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,5,14,5C14,4.72,13.89,4.47,13.71,4.29C13.71,4.29,13.71,4.29,13.71,4.29ZM7,6C7,6,9,6,9,6C9,6,9,8,9,8C9,8,7,8,7,8C7,8,7,6,7,6C7,6,7,6,7,6ZM4,6C4,6,6,6,6,6C6,6,6,8,6,8C6,8,4,8,4,8C4,8,4,6,4,6C4,6,4,6,4,6ZM6,14C6,14,4,14,4,14C4,14,4,12,4,12C4,12,6,12,6,12C6,12,6,14,6,14C6,14,6,14,6,14ZM9,14C9,14,7,14,7,14C7,14,7,12,7,12C7,12,9,12,9,12C9,12,9,14,9,14C9,14,9,14,9,14ZM12,14C12,14,10,14,10,14C10,14,10,12,10,12C10,12,12,12,12,12C12,12,12,14,12,14C12,14,12,14,12,14ZM12,11C12,11,4,11,4,11C4,11,4,9,4,9C4,9,12,9,12,9C12,9,12,11,12,11C12,11,12,11,12,11ZM12,8C12,8,10,8,10,8C10,8,10,6,10,6C10,6,12,6,12,6C12,6,12,8,12,8C12,8,12,8,12,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SimCard',
} as DefineComponent
</script>
